export const BANK_ACCOUNTS_BASE_QUERY_KEY = 'bank-accounts';

export const bankAccountsApiQueryKeys = {
  all: () => [BANK_ACCOUNTS_BASE_QUERY_KEY] as const,
};
